module.exports = __webpack_public_path__ + "img/SCB.dfbeb500.jpeg";